import React from 'react';
import Profile from 'views/Profile';

import ListUsers from 'views/Users/List';
import CreateUsers from 'views/Users/Create';
import EditUsers from 'views/Users/Edit';
import ViewUsers from 'views/Users/View';

import ListRequests from 'views/Requests/List';
import EditRequests from 'views/Requests/Edit';
import ShowRequests from 'views/Requests/Show';
import Editor from 'views/Requests/Editor';

import ListOOSS from 'views/OOSS/List';
import EditOOSS from 'views/OOSS/Edit';
import CreateOOSS from 'views/OOSS/Create';

import ListRemitos from 'views/Remitos/List';
import CreateRemitos from 'views/Remitos/Create';
import ShowRemitos from 'views/Remitos/Show';

import ListBSO from 'views/BSO/List';
import CloseBSO from 'views/BSO/Close';
import CreateBSO from 'views/BSO/Create';
import AuditBSO from 'views/BSO/Audit';
import ViewBSO from 'views/BSO/View';

import ListPresentation from 'views/Presentation/List';
import CreatePresentation from 'views/Presentation/Create';
import EditPresentation from 'views/Presentation/Edit';

import ViewMatriculatesMatriculas from 'views/MatriculatesRequests/Matriculas/View';
import EditMatriculatesMatriculas from 'views/MatriculatesRequests/Matriculas/Edit';
import ViewMatriculatesRematriculacion from 'views/MatriculatesRequests/Rematriculacion/View';
import EditMatriculatesRematriculacion from 'views/MatriculatesRequests/Rematriculacion/Edit';
import ViewMatriculatesCancelation from 'views/MatriculatesRequests/Cancelation/View';
import EditMatriculatesCancelation from 'views/MatriculatesRequests/Cancelation/Edit';
import ViewMatriculatesSuspension from 'views/MatriculatesRequests/Suspension/View';
import EditMatriculatesSuspension from 'views/MatriculatesRequests/Suspension/Edit';
import ViewMatriculatesBaja from 'views/MatriculatesRequests/Baja/View';
import EditMatriculatesBaja from 'views/MatriculatesRequests/Baja/Edit';
import ViewMatriculatesFormaPago from 'views/MatriculatesRequests/FormaPago/View';
import EditMatriculatesFormaPago from 'views/MatriculatesRequests/FormaPago/Edit';
import ViewMatriculatesConsultorio from 'views/MatriculatesRequests/Consultorios/View';
import EditMatriculatesConsultorio from 'views/MatriculatesRequests/Consultorios/Edit';
import ViewMatriculatesConsultorioBaja from 'views/MatriculatesRequests/ConsultoriosBaja/View';
import EditMatriculatesConsultorioBaja from 'views/MatriculatesRequests/ConsultoriosBaja/Edit';
import ViewMatriculatesConsultorioRenovacion from 'views/MatriculatesRequests/ConsultoriosRenovacion/View';
import EditMatriculatesConsultorioRenovacion from 'views/MatriculatesRequests/ConsultoriosRenovacion/Edit';
import ViewMatriculatesConsultorioUpdateEdilicia from 'views/MatriculatesRequests/ConsultoriosUpdateEdilicia/View';
import EditMatriculatesConsultorioUpdateEdilicia from 'views/MatriculatesRequests/ConsultoriosUpdateEdilicia/Edit';
import ViewMatriculatesConsultorioUpdateDirector from 'views/MatriculatesRequests/ConsultoriosUpdateDirector/View';
import EditMatriculatesConsultorioUpdateDirector from 'views/MatriculatesRequests/ConsultoriosUpdateDirector/Edit';
import ViewMatriculatesConsultorioUpdatePropietario
  from 'views/MatriculatesRequests/ConsultoriosUpdatePropietario/View';
import EditMatriculatesConsultorioUpdatePropietario
  from 'views/MatriculatesRequests/ConsultoriosUpdatePropietario/Edit';
import ViewMatriculatesStaffMultiple from 'views/MatriculatesRequests/StaffMultiple/View';
import EditMatriculatesStaffMultiple from 'views/MatriculatesRequests/StaffMultiple/Edit';
import ViewMatriculatesStaff from 'views/MatriculatesRequests/Staff/View';
import EditMatriculatesStaff from 'views/MatriculatesRequests/Staff/Edit';
import ViewMatriculatesStaffBaja from 'views/MatriculatesRequests/StaffBaja/View';
import EditMatriculatesStaffBaja from 'views/MatriculatesRequests/StaffBaja/Edit';
import ViewMatriculatesFacturacionOOSS from 'views/MatriculatesRequests/FacturacionOOSS/View';
import EditMatriculatesFacturacionOOSS from 'views/MatriculatesRequests/FacturacionOOSS/Edit';
import ViewMatriculatesAccount from 'views/MatriculatesRequests/Account/View';
import EditMatriculatesAccount from 'views/MatriculatesRequests/Account/Edit';

import ListMatriculates from 'views/Matriculates/List';
import EditMatriculates from 'views/Matriculates/Edit';
import ListNoMatriculates from 'views/NoMatriculates/List';
import EditNoMatriculates from 'views/NoMatriculates/Edit';
import NotificationsMatriculates from 'views/Matriculates/Notifications';

import ListMatriculatesRequests from 'views/MatriculatesRequests/List';
import EditMatriculatesPhotos from 'views/MatriculatesRequests/Photos/Edit';
import EditMatriculatesProfile from 'views/MatriculatesRequests/Profile/Edit';
import ViewMatriculatesPhotos from 'views/MatriculatesRequests/Photos/View';
import ViewMatriculatesProfile from 'views/MatriculatesRequests/Profile/View';

import ListMatriculatesEthics from 'views/MatriculatesEthics/List';
import EditMatriculatesEthics from 'views/MatriculatesEthics/Edit';
import ViewMatriculatesEthics from 'views/MatriculatesEthics/View';

import ListNotifications from 'views/Notifications/List';
import CreateNotifications from 'views/Notifications/Create';
import EditNotifications from 'views/Notifications/Edit';

import Help from 'views/Help';
import Reports from 'views/Reports';
import Config from 'views/Config';
import Rules from 'views/Contents/Rules';
import InsurerModulesView from 'views/Contents/InsurerModules';
import IOMAModulesView from 'views/Contents/IOMAModules';
import SpecialtyModulesView from 'views/Contents/SpecialtyModules';
import OtherModulesView from 'views/Contents/OtherModules';
import InsurerRegulationsView from 'views/Contents/InsurerRegulations';
import Contents from 'views/Contents/Contents';
import Links from 'views/Contents/Links';
import NewsView from 'views/Contents/News';
import MinimumEthicsBannerView from 'views/Contents/MinimumEthicsBanner';

interface Route {
  path: string;
  name: string;
  icon: string;
  component: () => JSX.Element;
  layout: string;
  roles: number[];
  show: boolean;
}

const routes: Route[] = [
  {
    path: '/solicitudes',
    name: 'Solicitudes de Autorización',
    icon: 'ni ni-single-copy-04 text-blue',
    component: ListRequests,
    layout: '/admin',
    roles: [1, 2, 3, 4],
    show: true,
  },
  {
    path: '/solicitudes/:id/editor',
    name: 'Ver solicitud',
    icon: 'ni ni-single-copy-04 text-blue',
    component: Editor,
    layout: '/admin',
    show: false,
    roles: [1, 3],
  },
  {
    path: '/solicitudes/:id/edit',
    name: 'Ver solicitud',
    icon: 'ni ni-single-copy-04 text-blue',
    component: EditRequests,
    layout: '/admin',
    show: false,
    roles: [1, 2, 3, 4],
  },
  {
    path: '/solicitudes/:id',
    name: 'Ver solicitud',
    icon: 'ni ni-single-copy-04 text-blue',
    component: ShowRequests,
    layout: '/admin',
    show: false,
    roles: [1, 2, 3, 4],
  },
  {
    path: '/ayuda',
    name: 'Ayuda',
    icon: 'ni ni-support-16 text-blue',
    component: Help,
    layout: '/admin',
    roles: [2, 3, 4, 7, 8],
    show: true,
  },
  /* REMITOS */
  {
    path: '/remitos',
    name: 'Remitos de Documentación',
    icon: 'ni ni-ungroup text-blue',
    component: ListRemitos,
    layout: '/admin',
    show: true,
    roles: [1, 3, 4],
  },
  {
    path: '/remitos/nuevo',
    name: 'Generar remitos',
    icon: 'ni ni-ungroup text-blue',
    component: CreateRemitos,
    layout: '/admin',
    show: false,
    roles: [1, 3, 4],
  },
  {
    path: '/remitos/:id',
    name: 'Gestión de Remitos',
    icon: 'ni ni-collection text-blue',
    component: ShowRemitos,
    layout: '/admin',
    show: false,
    roles: [1, 2, 3, 4],
  },
  // Facturas
  {
    path: '/pedidos-presentacion',
    name: 'Facturación Online',
    icon: 'ni ni-collection text-blue',
    component: ListBSO,
    layout: '/admin',
    show: true,
    roles: [1, 2, 4],
  },
  {
    path: '/pedidos-presentacion/nuevo',
    name: 'Nuevo Pedido de Presentación',
    icon: 'ni ni-collection text-blue',
    component: CreateBSO,
    layout: '/admin',
    show: false,
    roles: [1, 2, 4],
  },
  {
    path: '/pedidos-presentacion/cierre',
    name: 'Cerrar Pedido de Presentación',
    icon: 'ni ni-collection text-blue',
    component: CloseBSO,
    layout: '/admin',
    show: false,
    roles: [1, 2, 4],
  },
  {
    path: '/pedidos-presentacion/:id/audit',
    name: 'Auditar Factura Presendata',
    icon: 'ni ni-collection text-blue',
    component: AuditBSO,
    layout: '/admin',
    show: false,
    roles: [1, 2, 4],
  },
  {
    path: '/pedidos-presentacion/:id',
    name: 'Ver Facturación',
    icon: 'ni ni-collection text-blue',
    component: ViewBSO,
    layout: '/admin',
    show: false,
    roles: [1, 2, 4],
  },
  // PROFILE
  {
    path: '/profile',
    name: 'Editar perfil',
    icon: 'ni ni-single-02 text-yellow',
    component: Profile,
    layout: '/admin',
    show: false,
    roles: [1, 2, 3, 4, 7, 8],
  },
  // Gestión de presentaciones
  {
    path: '/presentations',
    name: 'Gestión de Presentaciones',
    icon: 'ni ni-collection text-blue',
    component: ListPresentation,
    layout: '/admin',
    show: true,
    roles: [1, 3, 4],
  },
  {
    path: '/presentations/create',
    name: 'Gestión de Presentaciones',
    icon: 'ni ni-collection text-blue',
    component: CreatePresentation,
    layout: '/admin',
    show: false,
    roles: [1, 3, 4],
  },
  {
    path: '/presentations/:id/edit',
    name: 'Gestión de Presentaciones',
    icon: 'ni ni-collection text-blue',
    component: EditPresentation,
    layout: '/admin',
    show: false,
    roles: [1, 3, 4],
  },
  // Matriculados
  {
    path: '/matriculates',
    name: 'Matriculados',
    icon: 'fas fa-user-md text-blue',
    component: ListMatriculates,
    layout: '/admin',
    show: true,
    roles: [1, 8],
  },
  {
    path: '/matriculates/:id/edit',
    name: 'Matriculados',
    icon: 'fas fa-user-md text-blue',
    component: EditMatriculates,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/:id/notifications',
    name: 'Matriculados',
    icon: 'fas fa-user-md text-blue',
    component: NotificationsMatriculates,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // No Matriculados
  {
    path: '/no-matriculates',
    name: 'No Matriculados',
    icon: 'fas fa-user text-blue',
    component: ListNoMatriculates,
    layout: '/admin',
    show: true,
    roles: [1, 8],
  },
  {
    path: '/no-matriculates/:id/edit',
    name: 'No Matriculados',
    icon: 'fas fa-user text-blue',
    component: EditNoMatriculates,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/requests',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: ListMatriculatesRequests,
    layout: '/admin',
    show: true,
    roles: [1, 8],
  },
  {
    path: '/matriculates/foto/:id/edit',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: EditMatriculatesPhotos,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/perfil/:id/edit',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: EditMatriculatesProfile,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/foto/:id',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: ViewMatriculatesPhotos,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/perfil/:id',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: ViewMatriculatesProfile,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Matriculas
  {
    path: '/matriculates/matriculas/:id/edit',
    name: 'Matriculas',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesMatriculas,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/matriculas/:id',
    name: 'Matriculas',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesMatriculas,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Rematriculación
  {
    path: '/matriculates/rematriculacion/:id/edit',
    name: 'Rematriculación',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesRematriculacion,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/rematriculacion/:id',
    name: 'Rematriculación',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesRematriculacion,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Cancelación
  {
    path: '/matriculates/cancelation/:id/edit',
    name: 'Cancelation',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesCancelation,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/cancelation/:id',
    name: 'Cancelation',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesCancelation,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Suspension
  {
    path: '/matriculates/suspension/:id/edit',
    name: 'Suspension',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesSuspension,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/suspension/:id',
    name: 'Suspension',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesSuspension,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Baja
  {
    path: '/matriculates/baja/:id/edit',
    name: 'Baja',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/baja/:id',
    name: 'Baja',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Forma de Pago
  {
    path: '/matriculates/forma_pago/:id/edit',
    name: 'Forma de Pago',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesFormaPago,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/forma_pago/:id',
    name: 'Forma de Pago',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesFormaPago,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Consultorios
  {
    path: '/matriculates/consultorio/:id/edit',
    name: 'Consultorio',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorio,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio/:id',
    name: 'Consultorio',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorio,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Consultorios Baja
  {
    path: '/matriculates/consultorio_baja/:id/edit',
    name: 'Consultorio Baja',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorioBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_baja/:id',
    name: 'Consultorio Baja',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorioBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Consultorios Renovación
  {
    path: '/matriculates/consultorio_renovacion/:id/edit',
    name: 'Consultorio Renovación',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorioRenovacion,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_renovacion/:id',
    name: 'Consultorio Renovación',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorioRenovacion,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Consultorios Updates
  {
    path: '/matriculates/consultorio_update_edilicia/:id/edit',
    name: 'Consultorio Actualización Edilicia',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorioUpdateEdilicia,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_update_edilicia/:id',
    name: 'Consultorio Actualización Edilicia',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorioUpdateEdilicia,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_update_director/:id/edit',
    name: 'Consultorio Actualización de Director',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorioUpdateDirector,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_update_director/:id',
    name: 'Consultorio Actualización de Director',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorioUpdateDirector,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_update_propietario/:id/edit',
    name: 'Consultorio Actualización de Propietario',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesConsultorioUpdatePropietario,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/consultorio_update_propietario/:id',
    name: 'Consultorio Actualización de Propietario',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesConsultorioUpdatePropietario,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Staff Múltiple
  {
    path: '/matriculates/staff_multiple/:id/edit',
    name: 'Staff Múltiple',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesStaffMultiple,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/staff_multiple/:id',
    name: 'Staff Múltiple',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesStaffMultiple,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Staff
  {
    path: '/matriculates/staff/:id/edit',
    name: 'Staff',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesStaff,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/staff/:id',
    name: 'Staff',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesStaff,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Staff Baja
  {
    path: '/matriculates/staff_baja/:id/edit',
    name: 'Staff Baja',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesStaffBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/staff_baja/:id',
    name: 'Staff Baja',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesStaffBaja,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Facturación OOSS
  {
    path: '/matriculates/facturacion_ooss/:id/edit',
    name: 'Facturación OOSS',
    icon: 'fas fa-file-pen text-blue',
    component: EditMatriculatesFacturacionOOSS,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/facturacion_ooss/:id',
    name: 'Facturación OOSS',
    icon: 'fas fa-file-pen text-blue',
    component: ViewMatriculatesFacturacionOOSS,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Datos mi cuenta
  {
    path: '/matriculates/account/:id/edit',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: EditMatriculatesAccount,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/account/:id',
    name: 'Solicitudes',
    icon: 'fas fa-mobile-alt text-blue',
    component: ViewMatriculatesAccount,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  // Certificados de Ética
  {
    path: '/matriculates/ethics',
    name: 'Certificados de Ética',
    icon: 'fas fa-mobile-alt text-blue',
    component: ListMatriculatesEthics,
    layout: '/admin',
    show: true,
    roles: [1, 8],
  },
  {
    path: '/matriculates/ethics/:id/edit',
    name: 'Certificados de Ética',
    icon: 'fas fa-mobile-alt text-blue',
    component: EditMatriculatesEthics,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/matriculates/ethics/:id',
    name: 'Certificados de Ética',
    icon: 'fas fa-mobile-alt text-blue',
    component: ViewMatriculatesEthics,
    layout: '/admin',
    show: false,
    roles: [1, 8],
  },
  {
    path: '/contenidos/enlaces',
    name: 'Enlaces Dinámicos',
    icon: 'fas fa-file-alt text-blue',
    component: () => React.createElement(Links),
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/enlaces-aranceles',
    name: 'Enlaces de Aranceles',
    icon: 'fas fa-file-alt text-blue',
    component: () => React.createElement(Links, { section: 'aranceles', title: 'Lista de Enlaces de Aranceles' }),
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/enlaces-formularios',
    name: 'Enlaces de Formularios para Facturar',
    icon: 'fas fa-file-alt text-blue',
    component: () => React.createElement(Links, {
      section: 'formularios',
      title: 'Lista de Enlaces de Formularios para Facturar',
    }),
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/normas',
    name: 'Normas de Facturación',
    icon: 'fas fa-file-alt text-blue',
    component: Rules,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/modulos-obras-sociales',
    name: 'Módulos Obras Sociales',
    icon: 'fas fa-file-alt text-blue',
    component: InsurerModulesView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/modulos-ioma',
    name: 'Módulos IOMA',
    icon: 'fas fa-file-alt text-blue',
    component: IOMAModulesView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/modulos-especialidad',
    name: 'Módulos Especialidad',
    icon: 'fas fa-file-alt text-blue',
    component: SpecialtyModulesView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/modulos-otras-practicas',
    name: 'Otras Prácticas Kinésicas',
    icon: 'fas fa-file-alt text-blue',
    component: OtherModulesView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/reglamento-obras-sociales',
    name: 'Reglamento Interno Obras Sociales',
    icon: 'fas fa-file-alt text-blue',
    component: InsurerRegulationsView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/banner-minimo-etico',
    name: 'Banner del Mínimo Ético',
    icon: 'fas fa-file-alt text-blue',
    component: MinimumEthicsBannerView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos/novedades',
    name: 'Novedades',
    icon: 'fas fa-file-alt text-blue',
    component: NewsView,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/contenidos',
    name: 'Contenidos',
    icon: 'fas fa-file-alt text-blue',
    component: Contents,
    layout: '/admin',
    show: true,
    roles: [1],
  },
  {
    path: '/notifications/create',
    name: 'Notificaciones App',
    icon: 'far fa-bell text-blue',
    component: CreateNotifications,
    layout: '/admin',
    show: false,
    roles: [1, 7],
  },
  {
    path: '/notifications',
    name: 'Notificaciones App',
    icon: 'far fa-bell text-blue',
    component: ListNotifications,
    layout: '/admin',
    show: true,
    roles: [1, 7],
  },
  {
    path: '/notifications/:id',
    name: 'Notificaciones App',
    icon: 'far fa-bell text-blue',
    component: EditNotifications,
    layout: '/admin',
    show: false,
    roles: [1, 7],
  },
  // USUARIOS
  {
    path: '/usuarios',
    name: 'Usuarios',
    icon: 'ni ni-single-02 text-blue',
    component: ListUsers,
    layout: '/admin',
    roles: [1],
    show: true,
  },
  {
    path: '/usuarios/crear',
    name: 'Crear usuario',
    icon: 'ni ni-single-02 text-red',
    component: CreateUsers,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/usuarios/:id',
    name: 'Ver usuario',
    icon: 'ni ni-single-02 text-red',
    component: ViewUsers,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/usuarios/:id/edit',
    name: 'Editar usuario',
    icon: 'ni ni-single-02 text-red',
    component: EditUsers,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  // OBRAS SOCIALES
  {
    path: '/obras-sociales',
    name: 'Obras sociales',
    icon: 'ni ni-bullet-list-67 text-blue',
    component: ListOOSS,
    layout: '/admin',
    roles: [1, 4],
    show: true,
  },
  {
    path: '/obras-sociales/nueva',
    name: 'Obras sociales',
    icon: 'ni ni-bullet-list-67 text-blue',
    component: CreateOOSS,
    layout: '/admin',
    show: false,
    roles: [1],
  },
  {
    path: '/obras-sociales/:id',
    name: 'Obras sociales',
    icon: 'ni ni-bullet-list-67 text-blue',
    component: EditOOSS,
    layout: '/admin',
    show: false,
    roles: [1, 4],
  },
  {
    path: '/reports',
    name: 'Reportes',
    icon: 'ni ni-chart-pie-35 text-blue',
    component: Reports,
    layout: '/admin',
    show: true,
    roles: [1, 2, 3],
  },
  {
    path: '/config',
    name: 'Configuración',
    icon: 'ni ni-ui-04 text-red',
    component: Config,
    layout: '/admin',
    show: true,
    roles: [1, 2, 3],
  },
];

export default routes;
